// Starts a page once its language is here: a French page downloads no dictionary, an Arabic or English one only its own.
// Nothing here may import shared/i18n.js, which reads the dictionary when it loads. If the file can't be fetched, the page
// starts in French rather than not at all.
const load = { ar: () => import('../../../shared/i18n/ar.js'), en: () => import('../../../shared/i18n/en.js') };

export function boot(start) {
  const m = /^\/(ar|en)(?=\/|$)/.exec(location.pathname);
  if (!m) return start();
  return load[m[1]]().then((d) => { globalThis.__TAV_DICT = { [m[1]]: d.default }; }).catch(() => {}).then(start);
}
